import { AriaRole, useId } from "react";
import cx from "classnames";

import useTypedContext from "hooks/useTypedContext";
import { ThemeContext } from "views/Theme";
import Box, { BoxProps } from "ds/components/Box";

import styles from "./styles.module.css";
import { CollapsibleSectionContext } from "./Context";

type CollapsibleSectionWrapperProps = BoxProps & {
  ref?: React.ForwardedRef<HTMLDivElement>;
  isCollapsed: boolean;
  onToggle: () => void;
  role?: AriaRole;
};

const CollapsibleSectionWrapper = ({
  children,
  isCollapsed,
  onToggle,
  className,
  ref,
  ...restBoxProps
}: CollapsibleSectionWrapperProps) => {
  const contentId = useId();

  const { reducedMotion } = useTypedContext(ThemeContext);

  return (
    <CollapsibleSectionContext.Provider value={{ isCollapsed, onToggle, contentId }}>
      <Box
        direction="column"
        fullWidth
        className={cx(styles.wrapper, className, {
          [styles.withTransition]: !reducedMotion,
        })}
        ref={ref}
        {...restBoxProps}
      >
        {children}
      </Box>
    </CollapsibleSectionContext.Provider>
  );
};

CollapsibleSectionWrapper.displayName = "DS.CollapsibleSection.Wrapper";

export default CollapsibleSectionWrapper;
